import config from '../../config';
export const waitUntilAnalyticsIsReady = (callback: () => void) => {
    if (!config.segmentApiKey) return callback();

    window.analytics
        .load(config.segmentApiKey)
        .then(() => {
            return new Promise<void>((resolve) => {
                window.analytics.ready(() => resolve());
            });
        })
        .then(() => callback())
        .catch(() => callback());
};
